class DeleteArticleUseCase {
    /**
     * @param {ArticleRepository} articleRepository
     */
    constructor(articleRepository) {
        this.articleRepository = articleRepository;
    }

    /**
     * @param {string} articleId
     * @returns {Promise<void>}
     */
    async execute(articleId) {
        return this.articleRepository.deleteArticle(articleId);
    }
}

export default DeleteArticleUseCase;
